import React, { useState } from "react";

import { Layout, Notification, UserMenu, MenuItemLink } from "react-admin";

import MoreVertIcon from "@material-ui/icons/MoreVert";

import { useUser } from "../../authenticatorApp/UserContext";
import DefaultError from "../../components/DefaultError";
import {
  AppInfoIcon,
  BugIcon,
  ContrastIcon,
  LogoutIcon,
  ProfileIcon,
  ThemeToggleIcon,
} from "../../components/common/iconography";
import { AppInfoDialog } from "../../components/common/AppInfoDialog";
import { MenuItemClickable } from "../../components/MenuItemClickable";

import { useThemeState } from "../../ThemeStateProvider";
import { CustomerMenu } from "./CustomerMenu";
import { CustomerAppBar } from "./CustomerAppBar";

const CustomerUserMenu = ({ toggleAppInfoOpen, ...props }) => {
  const { appUser } = useUser();
  const { toggleContrast, togglePalette } = useThemeState();
  const profilePath = `/customers/${appUser?.id}`;

  const handleBugReport = () => {
    window.open("https://transloads.co/submit-a-ticket/", "_blank");
  };

  return (
    <UserMenu label="USER" icon={<MoreVertIcon />}>
      <MenuItemLink
        to={profilePath}
        primaryText="Profile"
        leftIcon={<ProfileIcon />}
      />
      <MenuItemClickable
        primaryText="Theme"
        leftIcon={<ThemeToggleIcon />}
        clickHandler={togglePalette}
      />
      <MenuItemClickable
        primaryText="Contrast"
        leftIcon={<ContrastIcon />}
        clickHandler={toggleContrast}
      />
      <MenuItemClickable
        primaryText="App Info"
        leftIcon={<AppInfoIcon />}
        clickHandler={toggleAppInfoOpen}
      />
      <MenuItemClickable
        primaryText="Log a Ticket"
        leftIcon={<BugIcon />}
        clickHandler={handleBugReport}
      />
      <MenuItemLink
        to="/logout"
        primaryText="Logout"
        leftIcon={<LogoutIcon />}
      />
    </UserMenu>
  );
};

export const CustomerLayout = (props) => {
  const [appInfoOpen, setAppInfoOpen] = useState(false);
  const toggleAppInfoOpen = (_, reason) => {
    if (reason !== "backdropClick") setAppInfoOpen(!appInfoOpen);
  };
  const userMenu = <CustomerUserMenu toggleAppInfoOpen={toggleAppInfoOpen} />;

  return (
    <>
      <Layout
        {...props}
        appBar={(props) => CustomerAppBar(props, userMenu)}
        menu={CustomerMenu}
        notification={Notification}
        error={DefaultError}
      />
      <AppInfoDialog isOpen={appInfoOpen} onClose={toggleAppInfoOpen} />
    </>
  );
};
